export default function PageHeader({ title, subtitle, actions, badge }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-8">
      <div className="min-w-0">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-semibold text-hm-fg tracking-tight">
            {title}
          </h1>
          {badge && (
            <span className="mono text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-full border border-hm-border bg-hm-bg-1 text-hm-fg-muted">
              {badge}
            </span>
          )}
        </div>
        {subtitle && (
          <p className="mt-2 text-sm text-hm-fg-muted max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
